import { createStore, Store } from 'redux'
import { getMiddlewares } from './middlewares'
import { rootReducer, AppState } from './reducer'

export const getStore: () => Store<AppState> = () =>
  createStore(rootReducer, getMiddlewares())

export const store = getStore()
